// Re-export accent colors from @repo/tokens (single source of truth)
export {
  ACCENT_COLORS,
  ACCENT_COLOR_NAMES,
  DEFAULT_ACCENT,
} from '@repo/tokens';

export type { AccentColorName, AccentColorPair } from '@repo/tokens';
